export const ADD_BASKET = 'BASKET/ADD_BASKET';
export const DELETE_BASKET = 'BASKET/DELETE_BASKET';
export const CLEAR_BASKET = 'BASKET/CLEAR_BASKET';
export const CHANGE_COUNT_BASKET = 'BASKET/CHANGE_COUNT_BASKET';

export const ADD_FAVORITE = 'FAVORITE/ADD_FAVORITE';
export const DELETE_FAVORITE = 'FAVORITE/DELETE_FAVORITE';
export const CLEAR_FAVORITE = 'FAVORITE/CLEAR_FAVORITE';

export const CHANGE_CITY = 'CITY/CHANGE_CITY';
export const CHANGE_PHONE = 'CITY/CHANGE_PHONE';
